<template>
  <div>
    <div @drop="drop($event)" @input="doInput($event)" @dragover="dragover($event)" @dragleave="dragleave($event)">
      <div class="px-6 py-4" :class="focus ? 'input-select-focus' : 'input-select'">
        ファイルをドラッグ＆ドロップ、または、
        <label class="btn btn-sm btn-light border-dark" :class="focus ? 'pe-none' : ''">
          <input :multiple="multipleFile" ref="input" type="file" :accept="fileType" />選択
        </label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FileUploadCommon',
  data() {
    return {
      files: [],
      focus: false,
    };
  },
  props: {
    fileType: {
      type: String,
      default: '.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.png,.jpeg,.jpg',
    },
    canUpload: {
      type: Boolean,
      default: true,
    },
    multipleFile: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['dataInput'],
  methods: {
    dragover(event) {
      event.preventDefault();
      if (!this.focus) {
        this.focus = true;
      }
    },
    dragleave(event) {
      event.preventDefault();
      this.focus = false;
    },
    doInput(event) {
      event.preventDefault();
      this.files = [...event.target.files];
      this.$emit('dataInput', this.files);
      this.$refs.input.value = null;
    },
    drop(event) {
      event.preventDefault();
      this.focus = false;
      this.files = [...event.dataTransfer.files];
      this.$emit('dataInput', this.files);
      this.$refs.input.value = null;
    },
  },
};
</script>

<style scoped>
input[type='file'] {
  display: none;
}
.input-select {
  border: dotted 2px #b1b7c1;
  border-radius: 0.25rem;
}
.input-select-focus {
  border: dotted 2px #9ea4ad;
  border-radius: 0.25rem;
  background: #f2f2f2;
}
</style>
